module.exports = __webpack_public_path__ + "img/playbutton20.2e0741c8.png";